
<!-- src/views/StockView.vue -->
<template>
  <div class="stock-view">
    <template v-if="roleChecked && isOperations">
    <br>
      <div class="card stock-admin-tabs-card">
        <div class="card-content">
          <div
            class="core-tabs"
            role="tablist"
            aria-label="Stock administration"
          >
            <button
              type="button"
              class="core-tab"
              :class="{
                active: activeAdminTab === 'management'
              }"
              role="tab"
              :aria-selected="activeAdminTab === 'management'"
              @click="activeAdminTab = 'management'"
            >
              Stock Management
            </button>

            <button
              type="button"
              class="core-tab"
              :class="{
                active: activeAdminTab === 'suppliers'
              }"
              role="tab"
              :aria-selected="activeAdminTab === 'suppliers'"
              @click="activeAdminTab = 'suppliers'"
            >
              Supplier Access
            </button>
          </div>
        </div>
      </div>

      <StockDatabase
        v-if="activeAdminTab === 'management'"
        :current-user-profile="currentUserProfile"
      />

      <StockSupplierAccess
        v-if="activeAdminTab === 'suppliers'"
      />
    </template>

    <LiquorOrderStatus
      v-if="roleChecked && !isOperations"
      :current-user-profile="currentUserProfile"
    />

    <section class="card stock-count-card">
      <div class="card-content stock-count-card-content">
        <StockCountView
          :key="activeVenueId"
          :venue-id="activeVenueId"
          :current-user-profile="currentUserProfile"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  ref,
  unref,
} from "vue";

import { auth } from "@/firebase";

import {
  useVenueContext,
} from "@/scripts/useScripts/useVenueContext";

import StockDatabase from "@/components/stock/StockDatabase.vue";
import StockSupplierAccess from "@/components/stock/StockSupplierAccess.vue";
import StockCountView from "@/components/stock/StockCountView.vue";
import LiquorOrderStatus from "@/components/liquor/LiquorOrderStatus.vue";

const props = defineProps({
  currentUserProfile: {
    type: Object,
    default: () => ({}),
  },
});

const { venueId } = useVenueContext();

const activeVenueId = computed(() =>
  String(unref(venueId) ?? "").trim()
);

const activeAdminTab = ref("management");

const roleChecked = ref(false);
const operationsClaim = ref(false);

const profileIsOperations = computed(() => {
  const profile = props.currentUserProfile || {};

  const role = String(
    profile.role ||
    profile.user_type ||
    profile.userType ||
    ""
  )
    .trim()
    .toLowerCase();

  return (
    role === "operations" ||
    role === "ops" ||
    profile.isOperations === true ||
    profile.is_operations === true ||
    profile.operations === true ||
    profile.ops === true
  );
});

const isOperations = computed(() =>
  operationsClaim.value || profileIsOperations.value
);

async function checkOperationsAccess() {
  roleChecked.value = false;
  operationsClaim.value = false;

  try {
    const user = auth.currentUser;

    if (!user) {
      return;
    }

    const tokenResult = await user.getIdTokenResult();
    const claims = tokenResult?.claims || {};

    operationsClaim.value =
      claims.admin === true ||
      claims.operations === true ||
      claims.ops === true ||
      claims.is_operations === true;
  } catch (error) {
    console.error(
      "[StockView] Unable to check Operations access:",
      error
    );
  } finally {
    roleChecked.value = true;
  }
}

onMounted(checkOperationsAccess);
</script>

<style scoped>
.stock-view {
  box-sizing: border-box;
  width: 100%;
  padding: 0 0 32px;
}

.stock-admin-tabs-card {
  width: 96%;
  margin: 0 auto 16px;
}

.stock-count-card {
  box-sizing: border-box;
  width: 96%;
  max-width: none;
  margin: 24px auto 0;
  border-radius: 16px;
  overflow: hidden;
}

.stock-count-card-content {
  box-sizing: border-box;
  width: 100%;
  padding: 28px 32px 32px;
}

@media (max-width: 992px) {
  .stock-count-card,
  .stock-admin-tabs-card {
    width: 96%;
  }

  .stock-count-card-content {
    padding: 24px;
  }
}

@media (max-width: 600px) {
  .stock-view {
    padding-bottom: 20px;
  }

  .stock-count-card {
    width: calc(100% - 20px);
    margin-top: 16px;
    border-radius: 12px;
  }

  .stock-admin-tabs-card {
    width: calc(100% - 20px);
  }

  .stock-count-card-content {
    padding: 20px 16px 24px;
  }
}
</style>
